module.exports = __webpack_public_path__ + "static/media/bull-carbon.a3886200.png";